import { match, MatchFunction } from 'path-to-regexp';

interface Route {
  path: string;
  page: string;
}

const routeMap: Route[] = [
  { path: '/', page: 'Redirect to /member/AMC/memberlookup' },
  { path: '/:usertype/:partnercode/memberlookup', page: 'memberlookup' },
  { path: '/member/:partnercode', page: 'Lookup' },
  { path: '/:usertype/:partnercode/lookup', page: 'Lookup' },
  { path: '/:usertype/:partnercode/', page: 'Service Selection' },
  { path: '/:usertype/:partnercode', page: 'Service Selection' },
  { path: '/:usertype/:partnercode/home', page: 'Service Selection' },
  { path: '/:usertype/:partnercode/triage', page: 'Triage' },
  { path: '/:usertype/:partnercode/triage-steps', page: 'TriageSteps' },
  {
    path: '/:usertype/:partnercode/incident-report',
    page: 'IncidentReportForm',
  },
  { path: '/:usertype/:partnercode/help/:type', page: 'HelpStuck' },
  { path: '/:usertype/:partnercode/service-time', page: 'ServiceTime' },
  {
    path: '/:usertype/:partnercode/DisablementLocation',
    page: 'DisablementLocation',
  },
  { path: '/:usertype/:partnercode/location', page: 'Location' },
  { path: '/:usertype/:partnercode/confirm-vehicle', page: 'VehicleSelect' },
  { path: '/:usertype/:partnercode/add-vehicle', page: 'AddVehicle' },
  {
    path: '/:usertype/:partnercode/vehicle-search',
    page: 'VehicleSearchResults',
  },
  { path: '/:usertype/:partnercode/payment', page: 'Payment' },
  { path: '/appointment-confirmation', page: 'AppointmentConfirmation' },
  {
    path: '/:usertype/:partnercode/tracker/:sessionId/:callId/:requestId/:usageId/:language',
    page: 'Tracker',
  },
  {
    path: '/:usertype/:partnercode/tracker/:sessionId/:callId/:requestId/:usageId',
    page: 'Tracker',
  },

  {
    path: '/wd/:linkType/:partnerCode/:uuid/:usageId/:language',
    page: 'RescueTracker',
  },
  { path: '/wd/:linkType/:partnerCode/:uuid/:usageId', page: 'RescueTracker' },
  { path: '/:usertype/:partnercode/feedback', page: 'Feedback' },
  {
    path: '/:usertype/:partnercode/ServiceTransition',
    page: 'ServiceTransition',
  },
  { path: '/:usertype/:partnercode/sitedown', page: 'SiteDown' },
  { path: '/:usertype/:partnercode/ScheduleService', page: 'ScheduleService' },
  { path: '/:usertype/:partnercode/duplicaterescue', page: 'duplicaterescue' },
  { path: '/:usertype/:partnercode/CallUs', page: 'CallUs' },
];

export function getPageNameFromUrl(url: string): string {
  try {
    for (const route of routeMap) {
      const matcher: MatchFunction<Record<string, string>> = match(route.path, {
        decode: decodeURIComponent,
        sensitive: false, // Case-insensitive matching
      });
      const matched = matcher(url);
      if (matched) {
        return route.page;
      }
    }
    return url;
  } catch (error) {
    console.error('Error matching route:', error);
    return url;
  }
}